import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=ba3f11c0"
import script from "./Delete.vue?vue&type=script&setup=true&lang=js"
export * from "./Delete.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Delete.vue?vue&type=style&index=0&id=ba3f11c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports